export default "__VITE_ASSET__fV45rRWS__"